// extracted by mini-css-extract-plugin
export default {"avatar":"DiseasesComponent_avatar__sHjVs","high":"DiseasesComponent_high__xbofR","medium":"DiseasesComponent_medium__3zxGK"};